<!-- 试题内容 -->
<template>
  <el-dialog :visible.sync="centerDialogVisibleCopy" width="1000rem" class="elDialog" ref="dialog" title="题目赋分"
    :before-close="showConfirm" :close-on-click-modal="false">
    <el-dialog class="cfDialog" width="460rem" title="" :visible.sync="innerVisible" append-to-body>
      <div slot="title" class="dialog-header">
        关闭提示
      </div>
      <div class="dialog-content">修改内容未保存,是否直接关闭?</div>
      <div slot="footer" class="dialog-footer">
        <el-button class="preserveHandle cancel" type="primary" @click="noSaveClose">直接关闭</el-button>
        <el-button class="preserveHandle" type="primary" @click="preserveHandle">保 存</el-button>
      </div>

    </el-dialog>
    <vue-scroll class="coilingTable" :ops="ops" ref="coilingTable">
      <div class="coilingBox" ref="coilingBox">
        <div class="promptGive">
          <p>题目赋分值</p>
          <p>预计答题时长<br />（分钟）</p>
        </div>

        <div class="coilingBrief">
          <p>
            题数：<span>{{ subjectNum }}</span>
          </p>
          <p>
            总分：<span>{{ parseFloat(totalFraction) }} </span>
          </p>
          <p>
            预计答题时长：<span>{{ parseFloat(totalTime) }} 分钟</span>
          </p>
        </div>

        <div class="coilingChildStart coilingChild coilingChild1" v-for="item in questionNumber" :key="item.id">
          <!-- 一级题干 -->
          <div class="coilingInside" :style="{
            height:
              item.hasOwnProperty('children') && item.children.length
                ? '32rem'
                : '116rem',
          }">
            <div>
              {{ item.label
              }}<span>（{{ item.pyramid ? item.pyramid : 0 }}分）</span>
            </div>
          </div>

          <div v-if="!(item.hasOwnProperty('children') && item.children.length)" style="width: 100rem"
            class="coilingInput coilingLabel">
            <el-input class="scoreClass" v-model="item.score" @input="scoreChange($event, item)" size="mini"></el-input>
          </div>
          <div v-if="!(item.hasOwnProperty('children') && item.children.length)" style="width: 100rem;display:none"
            class="coilingInput">
            <!-- <el-input class="timeClass" v-model="item.time" @input="timeChange($event, item)" size="mini"></el-input> -->
          </div>

          <div class="coilingChildList" v-else>
            <div class="coilingChild" v-for="item1 in item.children" :key="item1.id">
              <!-- 二级题干 -->
              <div class="coilingInside coilingChild2" :style="{
                height:
                  item1.hasOwnProperty('children') && item1.children.length
                    ? '32rem'
                    : '74rem',
              }">
                <div :style="{
                  fontSize: item1.label.length > 2 ? '13rem' : '16rem',
                }">
                  {{ item1.label ? item1.label.substring(0, 2) : "Ⅱ" }}
                  <span>（{{ item1.pyramid ? item1.pyramid : 0 }}分）</span>
                </div>
              </div>

              <div v-if="
                !(item1.hasOwnProperty('children') && item1.children.length)
              " style="width: 70rem" class="coilingInput coilingLabel">
                <el-input class="scoreClass" v-model="item1.score" size="mini"
                  @input="scoreChange($event, item1)"></el-input>
              </div>
              <div v-if="
                !(item1.hasOwnProperty('children') && item1.children.length)
              " style="width: 70rem;display:none" class="coilingInput">
                <!-- <el-input class="timeClass" v-model="item1.time" @input="timeChange($event, item1)"
                  size="mini"></el-input> -->
              </div>

              <div class="coilingChildList" v-else>
                <div class="coilingChild coilingChild3" v-for="item2 in item1.children" :key="item2.id" :class="{
                  coilingLabelOne:
                    item1.hasOwnProperty('children') &&
                    item1.children.length == 1,
                }">
                  <!-- 三级题干 -->
                  <div class="coilingInside">
                    <div style="font-size: 14rem">{{ item2.label }}</div>
                  </div>

                  <div class="coilingInput coilingLabel">
                    <el-input class="scoreClass" v-model="item2.score" size="mini"
                      @input="scoreChange($event, item2)"></el-input>
                  </div>
                  <div class="coilingInput" style="display:none">
                    <!-- <el-input class="timeClass" v-model="item2.time" @input="timeChange($event, item2)"
                      size="mini"></el-input> -->
                  </div>
                  <!-- <div class="coilingChildList">
                      <div class="coilingChild"></div>
                    </div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="coilingInput">
            <el-input class="timeClass" v-model="item.time" @input="timeChange($event, item)" size="mini"></el-input>
          </div>
        </div>
      </div>
    </vue-scroll>

    <div class="preserveHandleBox">
      <!-- <el-button class="preserveHandle" type="primary" @click="noSaveClose">直接关闭</el-button> -->
      <el-button class="preserveHandle" type="primary" @click="preserveHandle">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { questionNumber } from "@/constants/constants";
import { EventBus } from "@/utils/event-bus";
import vueScroll from "vuescroll";

const TAG = "[GiveFraction.vue]";

export default {
  name: "GiveFraction",

  // props: ["centerDialogVisible"],

  props: {
    centerDialogVisible: {
      type: Boolean,
    },
    questionNumber: {
      type: Array,
      default: function () {
        return [];
      },
    },
    recoveryCoiling: {
      type: Function
    }
  },

  components: {
    vueScroll,
  },

  data() {
    return {
      subjectNum: 0, // 题数
      totalFraction: 0, // 总分
      totalTime: 0, // 总时长
      input: "",
      tempScore: "",
      scrollTop: 0, // 滚动条位置
      isOperate: false,
      questionNumber1: JSON.parse(JSON.stringify(questionNumber)),
      // questionNumber: [],
      centerDialogVisibleCopy: false,
      innerVisible: false,
      // 滚动条的配置信息
      ops: {
        vueScroll: {},
        scrollPanel: {
          speed: 300,
        },
        rail: {
          opacity: "0.1",
          border: "1rem solid #f2f2f2",
          size: "6rem",
        },
        bar: {
          size: "6rem",
          background: "#D9D9D9",
          keepShow: true,
        },
      },
    };
  },

  methods: {
    showConfirm() {
      this.innerVisible = true;

      // this.$confirm(`修改内容未保存,是否关闭?`, "关闭提示", {
      //   distinguishCancelAndClose: true,
      //   confirmButtonText: "保 存",
      //   cancelButtonText: "直接关闭",
      //   customClass: "customClass",
      //   confirmButtonClass: "btnConfirm",
      //   cancelButtonClass: "btnCancel",
      // })
      //   .then(() => {
      //     this.preserveHandle();
      //     //EventBus.$emit("deleteProgress", this.id);
      //   })
      //   .catch(() => {
      //     this.noSaveClose()
      //   });
    },
    noSaveClose() {
      this.centerDialogVisibleCopy = false;
      this.innerVisible = false;
      this.recoveryCoiling();
    },
    // 触发确定
    preserveHandle() {
      EventBus.$emit("giveSaveCoiling", this.questionNumber);
    },

    // 关闭弹框
    closeDialog() {
      setTimeout(() => {
        this.innerVisible = false;
        this.centerDialogVisibleCopy = false;
      }, 1000);
    },

    // 金字塔赋分发生变化
    pyramidChange(arr) {
      let itemScore = 0;

      for (let i = 0; i < arr.length; i++) {
        let itemI = arr[i];

        if (
          Object.prototype.hasOwnProperty.call(arr[i], "children") &&
          arr[i].children.length
        ) {
          arr[i].pyramid = this.pyramidChange(arr[i].children);
          itemScore = itemScore + this.pyramidChange(arr[i].children);
        } else {
          arr[i].pyramid = itemI.score;
          itemScore = itemScore + (arr[i].score - 0);
        }
      }

      return itemScore;
    },

    // 触发分数变化
    scoreChange(event, item) {
      // item.score = event.replace(/[^0-9.-]|(?<=\..*)\.|(?<!\d)\.|(?!^)-/g, "");

      let score = event
        .replace(/[^0-9.]|(?<=\..*)\.|(?<!\d)\.|(?!^)-/g, "")
        .split(".");

      
      let score1 = "";
      if (score.length == 1) {
        score1 = score[0].substring(0, 4);
      } else {
        score1 = score[0].substring(0, 3) + "." + score[1].substring(0, 1);
      }
      item.score = score1;
      setTimeout(()=>{
        this.totalFractionFn();
      },100)

      this.pyramidChange(this.questionNumber);
    },

    // 计算总分
    totalFractionFn() {
      let scoreClassList = document.getElementsByClassName("scoreClass");
      let total = 0;
      for (let i = 0; i < scoreClassList.length; i++) {
        let val = scoreClassList[i].children[0].value;
        let single = val ? val - 0 : 0;
        total += single;
      }
      if(isNaN(total)){
        total = 0;
      }
      this.totalFraction = total;
    },

    // 计算时长
    totalTimeFn() {
      let timeClassList = document.getElementsByClassName("timeClass");

      let total = 0;
      for (let i = 0; i < timeClassList.length; i++) {
        let val = timeClassList[i].children[0].value;
        let single = val ? val - 0 : 0;
        total += single;
      }
      if(isNaN(total)){
        total = 0;
      }
      this.totalTime = total;
    },

    // 触发时长变化
    timeChange(event, item) {
      // item.time = event.replace(/[^0-9.-]|(?<=\..*)\.|(?<!\d)\.|(?!^)-/g, "");

      let score = event
        .replace(/[^0-9.]|(?<=\..*)\.|(?<!\d)\.|(?!^)-/g, "")
        .split(".");
      let score1 = "";
      if (score.length == 1) {
        score1 = score[0].substring(0, 4);
      } else {
        score1 = score[0].substring(0, 3) + "." + score[1].substring(0, 2);
      }
      
      item.time = score1;

      setTimeout(()=>{
        this.totalTimeFn();
      },100)
    },
  },
  // watch: {},
  // // 销毁前
  // beforeDestroy() {},
  watch: {
    centerDialogVisible() {
      this.centerDialogVisibleCopy = this.centerDialogVisible;

      this.$nextTick(() => {
        this.subjectNum =
          document.getElementsByClassName("coilingLabel").length;
        console.log(TAG, "题数", this.subjectNum, this.questionNumber);

        if (this.centerDialogVisibleCopy) {
          this.totalFractionFn();
          this.totalTimeFn();
        }
      });

      if (this.centerDialogVisible) {
        this.$nextTick(() => {
          this.pyramidChange(this.questionNumber);

          console.log(
            TAG + "centerDialogVisible",
            this.centerDialogVisible,
            this.$refs.coilingTable
          );
          let coilingTable = this.$refs.coilingTable.clientWidth;
          let coilingBox = this.$refs.coilingBox.scrollWidth;

          console.log(TAG + "centerDialogVisible", coilingTable, coilingBox);
          if (coilingBox > coilingTable + 2) {
            this.$refs.coilingBox.style.justifyContent = "initial";
          } else {
            // style.color = 'red';
            this.$refs.coilingBox.style.justifyContent = "center";
          }
        });
      }
    },
    centerDialogVisibleCopy() {
      this.$emit("update:centerDialogVisible", this.centerDialogVisibleCopy);
    },
  },

  mounted() {
    EventBus.$on("closeDialog", this.closeDialog);
  },

  beforeDestroy() {
    EventBus.$off("closeDialog", this.closeDialog);
  },
};
</script>

<style lang="scss" scoped>
.coilingTable {
  height: 200rem;
  width: 100%;
  // overflow-x: scroll;
  border: 1rem solid #e9e9e9;
  padding-top: 15rem;
  min-width: 600rem;
}

.coilingBox {
  display: flex;
  flex-direction: row;
  // position: relative;
  padding-right: 20rem;
}

.coilingChildList {
  display: flex;
  flex-direction: row;
  justify-content: center;

  .coilingChild:only-child {
    width: 100%;

    .coilingInput {
      width: calc(100% - 10rem) !important;
    }
  }
}

.coilingChild {
  text-align: center;
  box-sizing: border-box;

}

.coilingChild2 {
  min-width: 50rem;
}

.coilingChild3 {
  width: 50rem;
  // background: #ccc;
  // margin: 1rem;
}

.coilingInside {
  height: 32rem;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;

  >div {
    width: 100%;
    height: 100%;
    background: #d5fae0;
    border-radius: 6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16rem;
    color: #303133;
    padding: 5rem;
    box-sizing: border-box;
    // font-weight: 600;

    span {
      font-size: 10rem;
      color: #303133;
      font-weight: 400;
    }
  }

  padding: 5rem;
}

.testContentBox {
  :deep .el-icon-star-on {
    color: #fcca00;
  }

  .tooltipIcon {
    cursor: pointer;
    font-size: 14rem;
    font-weight: 600;
    display: flex;
    align-items: center;

    img {
      margin-right: 2rem;
      width: 16rem;
      height: 16rem;
    }
  }
}

.elIconStar {
  font-size: 12rem;

  p {
    color: #ffb802;
    display: inline-block;
    cursor: pointer;

    img {
      width: 6rem;
      height: 11rem;
      position: relative;
      top: 1rem;
    }
  }
}

.enable {
  font-size: 14rem;
  color: #303133;
  margin: 0 16rem 0 20rem;
}

.btnAddressF {
  color: #fff;
}

.btnAddressPlain {
  background-image: none !important;
  color: #0bae6a;
  border-radius: 6rem;
  border-color: #0bae6a;
}

.btnAddressPlain:hover {
  color: #0bae6a;
}

:deep .el-dropdown-menu__item:hover {
  background: #d5fae0;
  color: #0bae6a;
}

.elDialog {
  :deep .el-dialog__body {
    padding: 0 30rem;
    margin-top: 12rem;
  }

  ::v-deep .el-dialog {
    border-radius: 10rem;
    height: auto !important;
    background: #f5f5f5;
  }

  :deep .el-tabs__item {
    padding: 6rem 16rem !important;
    height: auto;
    line-height: normal;
    color: #303133;
    background: #ecdcdc;
    border-radius: 6rem;
    margin-right: 10rem;
  }

  :deep .el-tabs__item.is-active {
    color: #fff;
    background: linear-gradient(to right, #09b17e, #08c162);
  }

  ::v-deep .el-dialog__title {
    padding-left: 26rem;

    &:before {
      content: "";
      position: absolute;
      left: 30rem;
      top: 22rem;
      width: 5rem;
      height: 20rem;
      border-radius: 10rem;
      background-color: var(--primary-color);
    }
  }

  .coilingTable {
    background: #fff;
    border-radius: 8rem;
    height: 320rem !important;
    // display: flex;
    // flex-direction: row;
    padding-top: 15rem !important;
    box-sizing: border-box;

    .promptGive {
      width: 112rem;
      // height: 310rem;
      padding-top: 132rem;

      >p {
        text-align: center;
        font-size: 12rem;
        color: #000;
        margin-bottom: 17rem;
      }
    }
  }

  .coilingInput {
    padding: 5rem;

    :deep .el-input__inner {
      padding: 0 3rem;
      text-align: center;
    }
  }

  .coilingBrief {
    position: absolute;
    top: 230rem;
    left: 317rem;
    height: 40rem;
    min-width: 300rem;
    background: #f6f6f6;
    border-radius: 8rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 3rem 0 5rem;

    >p {
      font-size: 14rem;
      color: #a8abb2;
      padding: 0 10rem;

      span {
        color: #303133;
      }
    }
  }

  :deep .__panel,
  :deep .__view {
    position: initial !important;
  }
}

.preserveHandleBox {
  display: flex;
  justify-content: end;
  padding: 16rem 0 22rem;

  .preserveHandle {
    width: 76rem;
    height: 32rem;
    padding: 0;
  }

  .preserveHandle:hover {
    width: 76rem;
    height: 32rem;
    padding: 0;
    background-image: var(--background-image);
    border-color: var(--primary-color);
  }
}

.coilingLabelOne {
  width: 80rem;
}

.cfDialog {
  ::v-deep .el-dialog {
    border-radius: 10rem;
    height: auto !important;
    .el-dialog__body{
      padding: 13rem 20rem;
    }
  }

  .dialog-header {
    margin-left: 10rem;
    font-size: 18rem;
    font-weight: 700;
  }

  .dialog-content{
    margin-left: 43rem;
  }

  .dialog-header::before {
    content: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAApdJREFUSEvNlk1IVFEUx3/PpjJTKtJKkxIyGdMYpBYTqCUaWLoY0T6gbVC7WhS1mKiwRZFQy1q0qkVCkvZlC8XEj4LaDI44i4pgJrBsIVg6pHnjds15b+Z9RWN0V+/dc+7/d8+559z3NCGE4B8O7f8Gzs/BSBDe3VY5KTkFO4KQ4XGdoz+L8M3JBOw3QkIrbi4B8PML6KsxF657Cev9rqDuIvwRhx4/TIbMRdftgrremrlLrDhhpg9DZBGxNOcjznIok5ipuQMlremyidgdMxeLod5uNKLL8Bqp+o56EWiHWo5+VroX4Esgptoc7A4aMQbU+I+K6D94x6T4586zHw3/sL4HgP9O83CnjPge+qmgudh8g1o72mDzbss4RaRygL5flO+PrWuHjbCdh9S829Pg7v7xjtOV6VWovetAaOXoHwhdSdbg5A5cPUM9R76tOepGAO/PYBnpUmCkW/KLcSagfUTG8VfBlM3ZQnGw6MmRaQOXAwAB+7zM9BtoRMmRxyU/rW0K/YcgT23E/RSAXGOmGoybrSVuRC04Syd+VDfNzat7ob8usNdiNQFkp3KciUWg3NA4dnlbVds/aTluxilY1lmYt+RmD4EoxetheR1sBChJ15zr7lrVAWNAHaFUqyrCwIOWQ2nEZGpooyp/iXZyJCu0JJFs3bq2Ym+p1wyq67DhUw+gCGD7lbLL1WblItMzvpfk3VYyhoRBNzM8KxUPSyG2uhauHyHmiET73uoFlFcHAMTYRbhemNYiVjd3k7ocsuoolHRYJpmzZIFpGl7r8LshjkMSTftXbQ1UVoot0jEHNOe0uremfOgicFmsfgRTY+stUphM5r4PiUIByHaATOxpUGuKoSCBvC16fpwaVApqs6/GGneyE++5g+RAjOCZQAAAABJRU5ErkJggg==);
    position: relative;
    top: 5rem;
    left: -13rem;
  }
}

.dialog-footer {
  .preserveHandle {
    width: 76rem;
    height: 32rem;
    padding: 0;
    background-image: var(--background-image);
    border-color: var(--primary-color);

    &.cancel {
      background: none;
      color: var(--primary-color);
      border-color: var(--primary-color);
    }

    &.cancel:hover {
      background-image: none;
      border-color: var(--primary-color);
    }
  }

  .preserveHandle:hover {
    width: 76rem;
    height: 32rem;
    padding: 0;
    background-image: var(--background-image);
    border-color: var(--primary-color);
  }
}
</style>